module.exports = __webpack_public_path__ + "static/media/upload_image_icon.2bd0f137.svg";